import {useLocation, useNavigate} from "react-router-dom";
import {useEffect} from "react";

// Pas utilisé dans l'immédiat mais pourrait être utile pour : suivi de navigation, navigation contextuelle et analyse comportement utilisateur
const LocationTracker = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const originalNavigate = navigate;

        navigate.enhancedNavigate = (to, options) => {
            const enhancedOptions = {
                ...options,
                state: {
                    ...(options?.state || {}),
                    usr: {
                        ...(options?.state?.usr || {}),
                        from: location
                    }
                }
            };

            return originalNavigate(to, enhancedOptions);
        };
    }, [location, navigate]);

    return <>{children}</>;
};

export default LocationTracker;